import { useAppDispatch, useAppSelector } from "hooks";
import { useEffect, useState } from "react";
import { setIsSTTMoreButtonClicked, setIsSTTToggledOn, setShowSmartLiveTextView } from "redux/actions/sttActions";
import { eventTypes } from "types/eventTracking";
import { useConfirmPrivilege } from "utils/customHook/useConfirmPrivilege";
import { trackEvent } from "utils/eventTracking";
import { SlidFeatures } from "utils/privilegeManager";

export const useDesktopSLTButton = () => {
  const { isSTTToggledOn, isManualAddingMode, isSTTActive } = useAppSelector((state) => state.sttReducer);
  const dispatch = useAppDispatch();
  const [SLTButtonStatus, setSLTButtonStatus] = useState<"waiting" | "recording" | "default">("default");
  const { confirmPrivilege, showInsufficientPrivilegeModal } = useConfirmPrivilege();

  const [isSTTHovered, setIsSTTHovered] = useState<boolean>(false);
  const [isMouseOnSTTButton, setIsMouseOnSTTButton] = useState<boolean>(false);

  useEffect(() => {
    const updateSLTButtonUI = () => {
      if (!isSTTToggledOn) {
        setSLTButtonStatus("default");
      } else if (isSTTActive) {
        setSLTButtonStatus("recording");
      } else if (isSTTToggledOn && !isSTTActive) {
        setSLTButtonStatus("waiting");
      }
    };
    updateSLTButtonUI();
  }, [isSTTToggledOn, isSTTActive]);

  const onMouseEnterSLTButton = () => {
    setIsSTTHovered(true);
    setIsMouseOnSTTButton(true);
  };

  const onMouseLeaveSLTButton = () => {
    setIsMouseOnSTTButton(false);
    setIsSTTHovered(false);
  };

  const onMouseEnterSLTMoreButton = () => {
    setIsSTTHovered(true);
  };

  const onMouseLeaveSLTMoreButton = () => {
    if (isMouseOnSTTButton) setIsSTTHovered(true);
  };

  const manageSmartLiveTextViewVisibility = () => {
    if (isManualAddingMode) dispatch(setShowSmartLiveTextView(true));
  };

  const onToggleOnSLTButton = async () => {
    manageSmartLiveTextViewVisibility();
    dispatch(setIsSTTToggledOn(true));
  };

  const onToggleOffSLTButton = () => {
    dispatch(setIsSTTToggledOn(false));
    if (!isManualAddingMode) dispatch(setShowSmartLiveTextView(false));
  };

  const onClickSLTMoreButton = (e) => {
    trackEvent({
      eventType: eventTypes.click.AUTO_TYPING_SETTING_IN_VIDEO_NOTE_PAGE,
      eventProperties: {
        location: isSTTActive ? "menu/set language" : "check all transcript",
      },
    });

    e.stopPropagation();
    dispatch(setShowSmartLiveTextView(true));
    // To keep showing SLT view when clicking this button even for auto mode users
    // isSTTMoreButtonClicked is reset as false when clicking the close button in SLT view
    dispatch(setIsSTTMoreButtonClicked(true));
  };

  const onClickSLTButton = async () => {
    trackEvent({
      eventType: isSTTToggledOn ? eventTypes.click.STOP_TYPING_IN_VIDEO_NOTE_PAGE : eventTypes.click.AUTO_TYPING_IN_VIDEO_NOTE_PAGE,
      eventProperties: {
        location: "video note main button",
      },
    });

    if (!isSTTToggledOn) {
      if (!confirmPrivilege(SlidFeatures.smartLiveText)) return showInsufficientPrivilegeModal();
      onToggleOnSLTButton();
    } else {
      onToggleOffSLTButton();
    }
  };

  return {
    onClickSLTButton,
    SLTButtonStatus,
    onClickSLTMoreButton,
    onMouseEnterSLTButton,
    onMouseLeaveSLTButton,
    onMouseEnterSLTMoreButton,
    onMouseLeaveSLTMoreButton,
    isSTTHovered,
    isMouseOnSTTButton,
  };
};
